<template>
  <div>
    <viewTable
      ref="viewTable"
      :limits="limits"
      :columns-property="columnsProperty"
      :filter="filter"
      module="basic"
      url="fm/calendarDate"
      @addOrEdit="addEditHandle"
      @delete="deleteHandle"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="特殊日期">
            <el-date-picker
              v-model="filter.specialDateStart"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="开始日期"
            />
            <span>-</span>
            <el-date-picker
              v-model="filter.specialDateEnd"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="结束日期"
            />
          </el-form-item>
          <el-form-item label="归属日历">
            <el-input v-model="filter.calendarName" placeholder="请输入日历名称" clearable />
          </el-form-item>
          <el-form-item label="日期类型">
            <el-select v-model="filter.dateType" placeholder="请选择日期类型" clearable>
              <el-option v-for="item in dateTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="原因">
            <el-input v-model.trim="filter.filter" placeholder="请输入原因" clearable />
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <CalendarDateEdit ref="calendarDateEdit" @save-success="loadData" />
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
import CalendarDateEdit from "./CalendarDateEdit";

export default {
  components: { viewTable, CalendarDateEdit },
  data() {
    return {
      limits: {
        addAuth: this.$auth(164),
        editAuth: this.$auth(165),
        delAuth: this.$auth(166),
      },
      dateTypeOptions: [
        { label: "法定节假日", value: 1 },
        { label: "计划检修停工", value: 2 },
        { label: "临时停产", value: 3 },
        { label: "调休工作日", value: 4 },
        { label: "半天停工", value: 5 },
        { label: "节假日加班", value: 6 },
      ],
      filter: {
        specialDateStart: "",
        specialDateEnd: "",
        calendarName: "",
        dateType: null,
        filter: "",
      },
      columnsProperty: [
        { tooltip: true, key: "specialDate", minWidth: 120, align: "center" },
        { tooltip: true, key: "calendarName", minWidth: 150 },
        { tooltip: true, key: "dateTypeName", width: 120, align: "center" },
        { tooltip: true, key: "reason", minWidth: 150 },
        { tooltip: true, key: "effectHour", width: 120, align: "right" },
        { key: "action", align: "center", width: 100, slot: "action" },
      ],
    };
  },
  methods: {
    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },
    addEditHandle(row) {
      this.$refs.calendarDateEdit.open(row);
    },
    deleteHandle(row) {
      this.$http.delete("basic", "fm/calendarDate", row.id).then((resp) => {
        if (resp.success) {
          this.$message.success("删除成功");
          this.loadData();
        }
      });
    },
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
    },
  },
};
</script>
